import { SanitizedText } from '@finn-no/tjt-common-components';
import { useSidebarContext } from '../../../state/SidebarContext';
import { OptedInType } from '../../../types/uiTypes';
import PriceEstimate from './PriceEstimate';
import { PropsWithChildren } from 'react';
import { Badge } from '@warp-ds/react';
import IconShipping16 from '@warp-ds/icons/react/shipping-16';

const FiksFerdigBadge = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
    return (
        <Badge
            variant="warning"
            className={`flex items-center gap-4 whitespace-nowrap ${className}`}
            data-testid="ship-it-badge"
        >
            {/* Warp badge types require wrapping children in Element, check if it's fixed after update. */}
            <>
                <IconShipping16 />
                {children}
            </>
        </Badge>
    );
};

const PriceTag = () => {
    const { uiText } = useSidebarContext();

    const {
        tradeTypeText,
        priceText,
        shippingPrice: { text, altText },
        priceEstimate,
        callout,
    } = uiText.sections.sidebar.optedIn as OptedInType;

    if (!priceText) return <h2 className="mb-4 md:mb-24">{tradeTypeText}</h2>;
    return (
        <div className="flex flex-col">
            <div className="w-full flex justify-between items-start">
                <h2 className=" text-m md:text-xs s-text md:s-text mb-0 mt-8">{tradeTypeText}</h2>
                {callout && <FiksFerdigBadge className="mt-8">{callout}</FiksFerdigBadge>}
            </div>
            <div className="mt-4">
                <div className="h2">{priceText}</div>
                {priceEstimate ? (
                    <PriceEstimate priceEstimate={priceEstimate} buttonText={text} />
                ) : (
                    <SanitizedText
                        text={text}
                        className="grow self-end text-s mb-16 mt-6 md:my-8"
                        altText={altText}
                    />
                )}
            </div>
        </div>
    );
};
export default PriceTag;
